import { useEffect, useState } from "react";
import { isStale } from "../utility/datetime.js";

export function useIsStale(lastSeen, intervalMs = 15000) {
  const [stale, setStale] = useState(() => isStale(lastSeen));
  useEffect(() => {
    setStale(isStale(lastSeen));
    const id = setInterval(() => setStale(isStale(lastSeen)), intervalMs);
    return () => clearInterval(id);
  }, [lastSeen, intervalMs]);
  return stale;
}
